export class EIMDescription{

	eimOptionData:String;
	eimOptionDesc:String;
	edited:boolean=undefined;
	editedCheck:String;
}